import gql from 'graphql-tag';

export default gql`
    query GetRoles {
        getRoles {
            id
            name
            displayName
        }
    }
`;
